import getConfig from 'next/config'

import { InfoClient } from '@Protos/info/info_pb_service'

const { publicRuntimeConfig } = getConfig()

let clientSingleton: InfoClient

export const getInfoClient = (): InfoClient => {
  if (clientSingleton) {
    return clientSingleton
  }

  clientSingleton = new InfoClient(publicRuntimeConfig.apiEndpoint)

  return clientSingleton
}
